export default "__VITE_ASSET__LM1i125H__"